import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';

// UI
import { SearchMap } from './search-map/search-map';
import { MapProvider } from '@components/map/map-context';
type Props = {};
export const Search: React.FC<Props> = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MapProvider><SearchMap /></MapProvider>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};